export default __webpack_public_path__ + "static/media/arrowDown.4772330e.svg";